import { type GTMPageData } from '../../helpers/analytics/gtm/gtm-types';
import { useCustomer } from '../apollo/customer/customer.hooks';
import { useEmployee } from '../apollo/employee/employee.hooks';

type UsePageDataResult = { pageData?: GTMPageData; isLoading: boolean };

export function usePageData(pageName: string): UsePageDataResult {
	const { loading: customerIsLoading, data, isPro } = useCustomer();

	const {
		loading: employeeIsLoading,
		employee: { id: employeeId, isAuthenticated: employeeIsAuthenticated, department: employeeDepartment }
	} = useEmployee();

	const isLoading = customerIsLoading || employeeIsLoading;

	if (isLoading || !data) {
		return { isLoading };
	} else {
		const { customer } = data;
		const pageData: GTMPageData = {
			customer: {
				isPro,
				userDBID: customer?.id ?? '0',
				email: customer?.hashedEmail ?? ''
			},
			employee: {
				department: employeeDepartment ?? null,
				employeeId,
				isAuthenticated: employeeIsAuthenticated
			},
			page: pageName
		};
		return { isLoading, pageData };
	}
}
